import { Phone, Mail, MessageCircle, MapPin, ArrowUpRight } from "lucide-react";
import { COMPANY, WHATSAPP_URL } from "@/lib/constants";

const CARDS = [
    {
        id: "phone",
        icon: Phone,
        iconBg: "bg-[#9B2C2C]",
        hoverColor: "group-hover:text-[#9B2C2C]",
        label: "Telefone",
        title: COMPANY.phone,
        titleClass: "text-2xl md:text-3xl uppercase",
        text: "Ligue-nos diretamente para atendimento imediato.",
        href: `tel:${COMPANY.phoneIntl}`,
        external: false,
    },
    {
        id: "whatsapp",
        icon: MessageCircle,
        iconBg: "bg-[#25D366]",
        hoverColor: "group-hover:text-[#25D366]",
        label: "WhatsApp",
        title: "Falar agora",
        titleClass: "text-2xl md:text-3xl uppercase",
        text: "Conversa rápida, partilhe fotos e obtenha orçamento.",
        href: WHATSAPP_URL,
        external: true,
    },
    {
        id: "email",
        icon: Mail,
        iconBg: "bg-[#2E7D5B]",
        hoverColor: "group-hover:text-[#2E7D5B]",
        label: "Email",
        title: COMPANY.email,
        titleClass: "text-lg md:text-xl break-all",
        text: "Envie-nos os detalhes por escrito quando quiser.",
        href: `mailto:${COMPANY.email}?subject=Pedido%20de%20Or%C3%A7amento%20-%20Lavlimpar`,
        external: false,
    },
];

const ContactCard = ({ card }) => (
    <a
        data-testid={`contact-cta-${card.id}`}
        href={card.href}
        {...(card.external ? { target: "_blank", rel: "noreferrer" } : {})}
        className="group bg-white p-8 md:p-10 hover:bg-white transition-colors reveal"
    >
        <div className="flex items-center justify-between mb-8">
            <div className={`w-14 h-14 ${card.iconBg} flex items-center justify-center`}>
                <card.icon className="w-6 h-6 text-white" />
            </div>
            <ArrowUpRight
                className={`w-6 h-6 text-[#0A0A0A]/30 ${card.hoverColor} group-hover:rotate-12 transition-all`}
            />
        </div>
        <div className="label-tag mb-2">{card.label}</div>
        <div
            className={`font-display font-black tracking-tight text-[#0A0A0A] mb-2 ${card.titleClass}`}
        >
            {card.title}
        </div>
        <p className="text-[#0A0A0A]/55 text-sm font-light">{card.text}</p>
    </a>
);

const ContactForm = () => (
    <section
        id="contacto"
        data-testid="contact-section"
        className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#F5F5F7] border-t border-black/10"
    >
        <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16 reveal">
                <div className="flex items-center justify-center gap-3 mb-6">
                    <span className="block w-12 h-px bg-[#9B2C2C]" />
                    <span className="label-tag" style={{ color: "#9B2C2C" }}>
                        Contacto
                    </span>
                    <span className="block w-12 h-px bg-[#9B2C2C]" />
                </div>
                <h2 className="font-display text-3xl md:text-4xl lg:text-6xl font-black uppercase tracking-tighter leading-[0.95] mb-6 text-[#0A0A0A]">
                    Peça o seu <span className="text-[#2E7D5B]">orçamento.</span>
                </h2>
                <p className="text-[#0A0A0A]/65 text-base md:text-lg leading-relaxed font-light max-w-2xl mx-auto">
                    Resposta rápida, transparente e sem compromisso. Contacte-nos
                    por telefone, WhatsApp ou email — respondemos no mesmo dia útil.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-black/10 border border-black/10 mb-12">
                {CARDS.map((c) => (
                    <ContactCard key={c.id} card={c} />
                ))}
            </div>

            <div
                data-testid="contact-area-band"
                className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 py-6 bg-white border border-black/10 reveal"
            >
                <div className="flex items-center gap-3">
                    <MapPin className="w-5 h-5 text-[#9B2C2C]" />
                    <span className="label-tag">Zonas de atuação</span>
                </div>
                <div className="font-display text-lg md:text-xl font-bold uppercase tracking-wide text-[#0A0A0A]">
                    Lisboa · Porto · Algarve
                </div>
            </div>
        </div>
    </section>
);

export default ContactForm;
